import { FunctionComponent } from 'react';
import { DraftTextOrPlaceholderTextConfiguration } from '@/types';
import { RendererProps } from '../ConfigurationRenderer';
import { useText } from './useText';
import './TextRenderer.scss';

export const TextReadOnlyRenderer: FunctionComponent<
  RendererProps<DraftTextOrPlaceholderTextConfiguration>
> = ({ configuration }) => {
  const [textElement, transform] = useText(configuration);

  return <g transform={transform}>{textElement}</g>;
};
